module.exports = __webpack_public_path__ + "static/media/userAccount.74afdc6f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/userAccount.svg
// module id = 2348
// module chunks = 0